import { PLAN_VALUES, SubscriptionPlan } from "@/constants/plans";

export function getStoredPlanOrDefault(): SubscriptionPlan {
    const stored = localStorage.getItem("selectedPlan");
  
    if (stored && PLAN_VALUES.includes(stored)) {
      return stored as SubscriptionPlan;
    }
    
    return SubscriptionPlan.EssentialMonthly;
  }